// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueI18n from 'vue-i18n'
import translations from './data/translations'
import Vue2Filters from 'vue2-filters'
import * as FastClick from 'fastclick'
import VueTouch from 'vue-touch'
import prefix from 'loglevel-plugin-prefix'
import {currentUserInfo, authenticate, createSession, getTasks, projectInfo, authenticateWithToken} from './lib/kronolog-client'
import detector from 'detector'

import AudioPlayer from './components/shared/audio-player.vue'

Vue.component('audio-player', AudioPlayer)

// Import and use vue-awesome
import Icon from 'vue-awesome/components/Icon.vue'

Vue.component('icon', Icon)

import 'vue-awesome/icons/volume-up'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/arrow-down'
import 'vue-awesome/icons/volume-off'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/times-circle'
import 'vue-awesome/icons/question-circle'
import log from './lib/logger'

window.$ = window.jQuery = require('jquery')

// Load vue plugins
Vue.use(Vue2Filters)
Vue.use(VueI18n)
Vue.use(VueTouch, {name: 'v-touch'})

Vue.config.productionTip = false

function browserInfo() {
    // TODO use Detector (and screen width) to filter old browsers
    var uniwin = {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.offsetWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.offsetHeight,
    }
    detector.scrrenWidth = screen.width
    detector.scrrenHeight = screen.height
    detector.colorDepth = screen.colorDepth
    detector.browserWidth = uniwin.width
    detector.browserHeight = uniwin.height
    return detector
}

function authenticated(to) {
    currentUserInfo().then(
        (response) => {
            // User is logged in, send to next task
            log.debug('Logged in')
            var tasks = ['srt', 'crt', 'dsb', 'dsf', 'vm', 'vismem', 'mst', 'pst', 'cod']
            var isTask = tasks.indexOf(to.path.substr(1))
            // If going to a task, is it the correct one according to state?
            if (isTask >= 0) {
                log.debug('[Router] Got a task navigation request')
                if (store.state.user.consent_given_at === null) {
                    log.warn('[Router] Task navigation request REJECTED: No consent')
                    router.replace('/dash')
                    return null
                }

                if (to.path.substr(1) !== store.getters.currentTask) {
                    log.warn(
                        '[Router] Task navigation request REJECTED: No not matching state (' +
                        store.getters.currentTask +
                        ')',
                    )
                    router.replace('/dash')
                    return null
                }
            }
        },
        (error) => {
            // User is not logged in, send to login
            log.debug(error)
            log.info('Not logged in')
            router.replace('/')
            return null
        },
    )
}

// Router beforeEach (global) navigation guards
router.beforeEach((to, from, next) => {
    /* AUTH
     *  For all other than login: Must be logged in
     *  For all tasks: Must have given consent
     *  For each task: Task must be current task in state
     */

    // Set project
    if (store.state.project.id == null) {
        // No project set, set the project
        projectInfo().then((result) => {
            store.commit('SET_PROJECT', result.data)
        }).catch((e) => {
            log.debug(e)
        })
    }

    // If login url, try to authenticate
    if (to.params.userID && to.params.projectID) {
        authenticate(to.params.userID, to.params.userID, to.params.projectID).then(response => {
            log.debug(response)
            currentUserInfo()
                .then((response) => {
                    window.dirty = true
                    // Set logger
                    var prefixDefaults = {
                        template: to.params.userID + '>>[%t]',
                        timestampFormatter: function (date) {
                            return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')
                        },
                        levelFormatter: function (level) {
                            return level.toUpperCase()
                        },
                        nameFormatter: function (name) {
                            return name || 'root'
                        },
                    }
                    prefix.apply(log, prefixDefaults)
                    let temp = response.data
                    temp.userId = to.params.userID
                    const userInfo = temp
                    log.info('Setting current user to: %o', userInfo)
                    store.commit('SET_USER', userInfo)
                    // Set taskstate
                    getTasks().then(
                        (result) => {
                            store.commit('SET_TASKSTATE', result.data.tasks)
                            log.debug(result)
                        },
                        (error) => {
                            log.error(error)
                            router.replace('/error')
                        }
                    )
                })
                .catch((error) => {
                    log.error('Unable to fetch current user', error)
                    router.replace('/link')
                })

            createSession(browserInfo()).then(
                (response) => {
                    if (store.state.user.consent_given_at !== null) {
                        const consent = {
                            status: true,
                            timestamp: store.state.user.consent_given_at,
                            upload: null,
                            completed: true,
                        }
                        if (store.state.user.wants_result_summary) {
                            store.commit('SET_CONSENT', consent)
                            // updateCurrentContext('resultsummary')
                            store.commit('SET_CURRENTCONTEXT', 'resultsummary')
                            log.info('User consent given, user wants feedback, moving on')
                        } else {
                            store.commit('SET_CONSENT', consent)
                            // updateCurrentContext('audiocheck')
                            store.commit('SET_CURRENTCONTEXT', 'audiocheck')
                            log.info('User consent given, moving on')
                        }
                    }
                    //  router.replace('/dash')
                },
                (error) => {
                    log.error('Unable to create session', error)
                    router.replace('/error')
                }
            )
            router.replace('/dash')
        }, (error) => {
            // Direct login didn't work, redirect to login
            log.debug(error)
            log.debug('Direct login failed, try manual login')
            // authenticated(to)
            router.replace('/link')
        })
    } else if (to.params.token) {
        authenticateWithToken(to.params.token).then(response => {
            log.debug(response)
            currentUserInfo()
                .then((response) => {
                    window.dirty = true
                    // Set logger
                    var prefixDefaults = {
                        template: to.params.userID + '>>[%t]',
                        timestampFormatter: function (date) {
                            return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')
                        },
                        levelFormatter: function (level) {
                            return level.toUpperCase()
                        },
                        nameFormatter: function (name) {
                            return name || 'root'
                        },
                    }
                    prefix.apply(log, prefixDefaults)
                    let temp = response.data
                    temp.userId = to.params.userID
                    const userInfo = temp
                    log.info('Setting current user to: %o', userInfo)
                    store.commit('SET_USER', userInfo)
                    // Set taskstate
                    getTasks().then(
                        (result) => {
                            store.commit('SET_TASKSTATE', result.data.tasks)
                            log.debug(result)
                        },
                        (error) => {
                            log.error(error)
                            router.replace('/error')
                        }
                    )
                })
                .catch((error) => {
                    log.error('Unable to fetch current user', error)
                    router.replace('/link')
                })

            createSession(browserInfo()).then(
                (response) => {
                    if (store.state.user.consent_given_at !== null) {
                        const consent = {
                            status: true,
                            timestamp: store.state.user.consent_given_at,
                            upload: null,
                            completed: true,
                        }
                        if (store.state.user.wants_result_summary) {
                            store.commit('SET_CONSENT', consent)
                            // updateCurrentContext('resultsummary')
                            store.commit('SET_CURRENTCONTEXT', 'resultsummary')
                            log.info('User consent given, user wants feedback, moving on')
                        } else {
                            store.commit('SET_CONSENT', consent)
                            // updateCurrentContext('audiocheck')
                            store.commit('SET_CURRENTCONTEXT', 'questions')
                            log.info('User consent given, moving on')
                        }
                    }
                    //  router.replace('/dash')
                },
                (error) => {
                    log.error('Unable to create session', error)
                    router.replace('/error')
                }
            )
            router.replace('/dash')
        }, (error) => {
            // Direct login didn't work, redirect to login
            log.debug(error)
            log.debug('Direct login failed, try manual login')
            // authenticated(to)
            router.replace('/link')
        })
    } else {
        authenticated(to)
    }

    log.debug('[Router] *NAV* From: ' + from.path + ' To: ' + to.path)
    next()
})

// Router afterEach (global) navigation guards
router.afterEach((to, from, next) => {
    log.info('[Router] Navigated from: ' + from.path + ' to: ' + to.path)
})

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'no', // set locale
    messages: translations,
    silentTranslationWarn: true
})

// Eksporter i18n for bruk i andre filer
export { i18n }

// eslint-disable-next-line
var vm = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: {App},
})

// Bind FastClick to body to remove 300ms delay in old mobile browsers
FastClick['attach'](document.body)

// Handle browser navigate away (deactivates when user logs out)
window.onbeforeunload = function () {
    log.info('User may have closed tab.')
    if (window.dirty) {
        return 'Are you sure you want to navigate away?'
    }
}
window.unload = function () {
    // Do something before unload?
    // e.g. send notice to server and invalidate login/session
    log.debug('Leaved page...')
}



// WEBPACK FOOTER //
// ./src/main.js